import * as e from "@amplitude/analytics-browser";
import i from "platform";
import { jsx as w } from "react/jsx-runtime";
import { MemoryStorage as y } from "@amplitude/analytics-core";
import { Experiment as v } from "@amplitude/experiment-js-client";
import { sessionReplayPlugin as C } from "@amplitude/plugin-session-replay-browser";
import { createContext as I, useMemo as d, useEffect as A, useContext as R } from "react";
const P = () => ({
  platform_os: i.os?.toString() ?? "unknown",
  platform_name: i.name ?? "unknown",
  platform_osVersion: i.version ?? "unknown",
  platform_product: i.product ?? "unknown",
  platform_manufacturer: i.manufacturer ?? "unknown",
  platform_layout: i.layout ?? "unknown",
  platform_description: i.description ?? "unknown"
}), G = () => "a09fe4add8580a204c36b1a34931cfdb", N = () => "client-I2mWf7HDaIlT8yL7qRWZAQ5kd4eZc3Gh", H = {
  disableExitSurvey: "disable-exit-survey",
  askForFeedbackOnResult: "ask-for-feedback-on-result",
  emailCollectionFeedback: "email-collector-feedback"
}, q = {
  control: "control",
  treatment: "treatment",
  variantA: "variant-a",
  variantB: "variant-b"
};
var x = /* @__PURE__ */ ((o) => (o.OpenSidebar = "visa open sidebar", o.CloseSidebar = "visa close sidebar", o.ShowQrCode = "visa show qr code", o.SignInStart = "visa show sign in", o.InputEmail = "visa input email", o.VerifiedEmail = "visa verified email", o.ShowScanList = "visa show scan list", o.SelectScan = "visa select scan", o.ClaimedScan = "visa claimed scan", o.OpenStoreFinder = "visa open store finder", o.ShowRecommendation = "visa show recommendation", o.ShowError = "visa show error", o.MeshViewInteraction = "visa user interact with mesh view", o.Feedback = "visa leave feedback", o.EmailCollectorWithGift = "visa leave email with gift", o.ShowFeedbackModal = "visa show feedbackModal", o.StartOverBT = "visa user tap on start over button", o.ShowRecommendationEducation = "visa show recommendation education", o.MoreInfoRecommendationEducation = "visa show more info link recommendation education", o.OpenPrivacyPolicy = "visa open privacy policy link", o.Checkout = "visa checkout", o.ExitScanning = "visa exit scanning", o.AgeRestriction = "visa age restriction modal", o.ContinueShopping = "visa tap continue shopping", o.NextResultEducationModal = "visa show next result education modal", o.ResultEducationModal = "visa tap show result education modal", o.CloseResultEducationModal = "visa close result education modal", o.CloseSizeChart = "visa user tap close size chart", o.FailLoadSizeChart = "visa failed to load size chart", o.ExitWithoutRecommendation = "visa user tap on exit without recommendation", o.GoToScannerFromSizeChart = "visa user tap on load scanner button", o.ContinueFromIntro = "visa user tap on continue on intro page", o.SizeChartNPS = "visa user rate size chart", o.SizeChartComment = "visa user submit comment on size chart", o.OnboardingCompleted = "web scanner complete onboarding", o.ValidationFailure = "web scanner fail validation", o.ReconstructionFailure = "web scanner fail reconstruction", o.ReconstructionStarted = "web scanner start reconstruction", o.ReconstructionSuccess = "web scanner succeed reconstruction", o.BackToIntro = "web scanner back to intro", o.BackToPicker = "web scanner back to picker", o.IntroLoadSolo = "web scanner load Solo on continue from Intro", o.PickerLoadNormal = "web scanner press scan my self", o.PickerLoadAssisted = "web scanner press assisted scanning", o.UserLeftWebpage = "web scanner leave page", o.UserTappedTryAgain = "web scanner try again", o.Capture1 = "web scanner capture stage1 complete", o.Capture2 = "web scanner capture stage2 complete", o.CaptureShot = "web scanner capture shot", o.PaperTypeChange = "web scanner user changed paper type", o.PaperSelected = "web scanner select paper size", o.CameraLoadingError = "web scanner failed to load camera", o.CameraPhotoError = "web scanner failed to take photo", o.AddBrandToSurvey = "web scanner add brand to fit survey", o.AddSizeToSurvey = "web scanner add size to fit survey", o.AddWidthToSurvey = "web scanner add width to fit survey", o.AddGenderToSurvey = "web scanner add gender age to fit survey", o.SubmitSurvey = "web scanner submit fit survey", o.SurveyRecommendationFailure = "web scanner failed fit survey recommendation", o.SurveyRecommendationStarted = "web scanner started fit survey recommendation", o.SurveyOnboardingCompleted = "web scanner complete onboarding fit survey", o.HybridSurvey = "web scanner show hybrid survey", o.ScannerIntro = "web scanner show hybrid scanning intro", o.SkipToResultHybrid = "web scanner user tap skip to result", o.HybridLeaveOnScannerIntro = "web scanner user tap close on scanning intro page", o.SkipFitSurvey = "web scanner user tap on skip fit survey in hybrid flow", o.SizeChartScroll = "web scanner user scroll size chart", o.SizeChartChangeLocale = "web scanner change size chart locale", o.SocksQuestion = "web scanner user response to socks question", o.OnboardingScannerDetail = "web scanner show onboarding scanner detail", o.LoadResultView = "result load view", o.FailLoadingScanResult = "result failed on loading scan", o.NextOnMeasurementsResult = "result user press next on measurements", o.BackOnMeasurementsResult = "result user press back on measurements", o))(x || {}), S = /* @__PURE__ */ ((o) => (o.Environment = "environment", o.TenantToken = "tenant_token", o))(S || {}), z = /* @__PURE__ */ ((o) => (o.SkipAndLeave = "skip and leave", o.Close = "close", o))(z || {});
class L {
  track = (a, n) => {
    const c = {
      ...n ? { ...n } : {},
      ...P()
    };
    e.track(a, c);
  };
  trackerUserId = () => e.getUserId();
  trackerDeviceId = () => e.getDeviceId();
}
const u = I(void 0);
function F() {
  const o = "volumentalTest";
  try {
    return localStorage.setItem(o, o), localStorage.removeItem(o), !0;
  } catch {
    return !1;
  }
}
const O = async (o) => {
  await o.fetch();
}, b = (o, a) => {
  const n = new e.Identify();
  n.set(o, a), e.identify(n);
}, f = () => {
  e.setTransport("beacon"), e.flush();
}, Q = ({
  amplitudeApiKey: o,
  experimentKey: a,
  debugMode: n = !1,
  disabled: m = !1,
  deviceId: c,
  optOut: h,
  children: r
}) => {
  if (m)
    return d(
      () => /* @__PURE__ */ w(
        u.Provider,
        {
          value: {
            isVariantActive: () => !1,
            getVariantPayload: () => {
            },
            getAllExperiments: () => ({}),
            setUserProperty: () => {
            },
            getSessionId: () => {
            },
            getDeviceId: () => {
            },
            optOutUser: () => {
            }
          },
          children: r
        }
      ),
      [r]
    );
  const l = d(() => {
    const t = F();
    if (e.getSessionId() === void 0) {
      e.init(o, {
        instanceName: "volumental",
        deviceId: c,
        identityStorage: t ? "localStorage" : "none",
        storageProvider: t ? void 0 : new y(),
        defaultTracking: {
          attribution: !0,
          fileDownloads: !1,
          formInteractions: !1,
          pageViews: !1,
          sessions: !0
        },
        optOut: h
      });
      const s = C({ sampleRate: 5e-3 });
      e.add(s);
    }
    if (b(S.Environment, "production"), t) {
      const s = v.initializeWithAmplitudeAnalytics(a, {
        debug: n,
        instanceName: "volumental"
      });
      return O(s), s;
    }
    return {
      variant: () => ({}),
      all: () => ({})
    };
  }, [n, o, a]), p = d(
    () => ({
      isVariantActive: (t, s = "on") => l.variant(t).value === s,
      getVariantPayload: (t) => l.variant(t).payload,
      getAllExperiments: () => l.all(),
      setUserProperty: b,
      getSessionId: e.getSessionId,
      getDeviceId: e.getDeviceId,
      optOutUser: e.setOptOut
    }),
    [l]
  );
  return A(() => (window.addEventListener("unload", f), () => {
    window.removeEventListener("unload", f);
  }), []), d(
    () => /* @__PURE__ */ w(u.Provider, { value: p, children: r }),
    [r, p]
  );
}, Z = () => {
  const o = R(u);
  if (!o)
    throw new Error("useAnalytics must be used within an AnalyticsProvider");
  return o;
}, j = new L();
export {
  Q as AnalyticsProvider,
  z as ExitReason,
  N as GetExperimentKey,
  G as GetTrackingKey,
  x as UsageTrackerEvent,
  S as UserProperty,
  H as VariantFlag,
  q as Variants,
  j as usageTracker,
  Z as useAnalytics
};
